var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUserRegular2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.5C11.5 13.1187 10.3813 12 9 12H7C5.61875 12 4.5 13.1187 4.5 14.5H4C3.725 14.5 3.5 14.275 3.5 14V2C3.5 1.725 3.725 1.5 4 1.5H9V4C9 4.55313 9.44687 5 10 5H12.5V14C12.5 14.275 12.275 14.5 12 14.5H11.5ZM4 0C2.89688 0 2 0.896875 2 2V14C2 15.1031 2.89688 16 4 16H12C13.1031 16 14 15.1031 14 14V4.82812C14 4.29688 13.7906 3.7875 13.4156 3.4125L10.5844 0.584375C10.2094 0.209375 9.70312 0 9.17188 0H4ZM10 9C10 8.46957 9.78929 7.96086 9.41421 7.58579C9.03914 7.21071 8.53043 7 8 7C7.46957 7 6.96086 7.21071 6.58579 7.58579C6.21071 7.96086 6 8.46957 6 9C6 9.53043 6.21071 10.0391 6.58579 10.4142C6.96086 10.7893 7.46957 11 8 11C8.53043 11 9.03914 10.7893 9.41421 10.4142C9.78929 10.0391 10 9.53043 10 9Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUserRegular2);
export default __webpack_public_path__ + "static/media/file-user-regular 2.fbe6b4f390b70202fc945cfe339aa67c.svg";
export { ForwardRef as ReactComponent };